<template>
  <div class="modal__Response" :class="{ 'is-Active': updated === true }">
    <lottie class="modal__ResponseAnimation" :options="defaultOptions" @animCreated="handleAnimation" />
    <p v-html="message"></p>
  </div>
</template>

<script>
import Lottie from '@/components/partials/Lottie'
import animationData from '@/assets/animations/simple_tick.json'

export default {
  components: {
    Lottie,
  },
  props: ['updated', 'message'],
  data() {
    return {
      defaultOptions: {
        animationData: animationData,
        loop: false,
        autoplay: false,
      },
    }
  },
  watch: {
    updated() {
      if (this.updated === true) {
        this.stop()
        setTimeout(() => {
          this.play()
        }, 300)
      }
    },
  },
  name: 'SuccessPrompt',
  methods: {
    handleAnimation(anim) {
      this.anim = anim
    },

    stop() {
      this.anim.stop()
    },

    play() {
      this.anim.play()
    },
  },
}
</script>
